import type { FaireOrderEntity } from "../../entity_types/order";

export const BN22VTEKTM: FaireOrderEntity = {
  token: "BN22VTEKTM",
  type: "order",
  orderNumber: "#BN22VTEKTM",
  status: "new",
  totalDollars: 100.16,
  customerName: "The Painted Door Boutique",
  firstOrder: true,
  placedAt: "Nov 28, 2025",
  sourceLabel: "Marketplace",
  commissionNote: "First order",
  payoutDate: "Pending Ship",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "entity-db-bootstrap",
  },
};
